import React, { useRef, useState } from 'react';
import { PlusOutlined } from '@ant-design/icons';
import { Button, Divider, Input, Modal, Select, Space } from 'antd';
import { gql, useMutation, useQuery } from '@apollo/client';
import { error, warning } from '../../Controllers/toast';

const GET_BLOCK_NAMES = gql`
  query GetPlantBlockNames($plant_id: Int!) {
    GetPlantBlockNames(plant_id: $plant_id) {
        block_name
        id
    }
  }
`;
const CREATE_BLOCK_NAME = gql`
mutation CreateBlockName($plant_id:Int!,$block_name: String!) {
  CreateBlockName(plant_id:$plant_id,block_name: $block_name) {
    block_name
    id
  }
}`



const BlockGroupsComponent = ({ plantId,setBlockName, setBlockNameId,blockNameId, activeId, Opt_Group_id, Block_Group_id }) => {
    const [items, setItems] = useState([]);
    const [name, setName] = useState('');

    const { loading, data, } = useQuery(GET_BLOCK_NAMES, {
        variables: { plant_id: parseInt(plantId) },
        onCompleted: (res) => {
            console.log(res.GetPlantBlockNames, "is response");
            setItems(res.GetPlantBlockNames);
            //   setPO_groups(res.GetOptimizers);
        },
        onError: (err) => {
            console.log(err);
            error("مشکلی در دریافت اطلاعات رخ داده است!");
        },

        //  notifyOnNetworkStatusChange: true,
        // pollInterval: 20000,
        // errorPolicy: "ignore",
    });
    const [createBlockName, { }] = useMutation(CREATE_BLOCK_NAME, {
        onCompleted: (res) => {
            console.log(res);

            setItems(prevItems => [
                ...prevItems,
                res.CreateBlockName
            ]);

        },
        onError: (err) => {
            // console.log(err);
            error(err.message);
        },
    })


    const inputRef = useRef(null);
    const onNameChange = (event) => {
        setName(event.target.value);
    };
    const addItem = (e) => {
        e.preventDefault();
        // console.log(name)
        // console.log(items.find(e => e.block_name === name))
        if(name.trim().length === 0){
            warning("لطفا نام بلوک را وارد کنید.")
            return ;
        }
        if(items.find(e => e.block_name === name)){
            warning("نام وارد شده تکراری می باشد!")
        }else{

            createBlockName({ variables: { block_name: name, plant_id: plantId } })
            // setItems([...items, name || `Block ${index++}`]);
            setName('');
            //     setTimeout(() => {
            //         inputRef.current?.focus();
            //     }, 0);
        }
    };

    // console.log(activeId)
    return (
        <Select
            value={activeId}
            style={{
                width: 300,
            }}
            placeholder="انتخاب بلوک های نیروگاه"
            dropdownRender={(menu) => {
                return (
                    <div>
                        {menu}
                        <Divider
                            style={{
                                margin: '8px 0',
                            }}
                        />
                        <Space
                            style={{
                                padding: '0 8px 4px',
                            }}
                        >
                            <Input
                                placeholder="نام بلوک جدید"
                                ref={inputRef}
                                value={name}
                                onChange={onNameChange}
                                onKeyDown={(e) => e.stopPropagation()}
                            />
                            <Button type="text" icon={<PlusOutlined />} onClick={addItem}>
                                ساخت بلوک
                            </Button>
                        </Space>
                    </div>
                )
            }}
            options={items.map((item) => ({
                label: item.block_name,
                value: item.id,
            }))}
            onSelect={item => {
                console.log(item , "is selected")
                setBlockNameId(item)
                // setBlockName(name)
            }}
        />
    );
};
export default BlockGroupsComponent;